import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("g", {
      fill: "none",
      "fill-rule": "evenodd"
    }, [
      _createElementVNode("g", null, [
        _createElementVNode("g", null, [
          _createElementVNode("path", {
            fill: "#252729",
            d: "M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 1.5c-4.694 0-8.5 3.806-8.5 8.5s3.806 8.5 8.5 8.5 8.5-3.806 8.5-8.5-3.806-8.5-8.5-8.5zm0 1.75c.38 0 .693.282.743.648L12.75 6v5.25H18c.414 0 .75.336.75.75 0 .38-.282.693-.648.743L18 12.75h-6c-.38 0-.693-.282-.743-.648L11.25 12V6c0-.414.336-.75.75-.75z",
            transform: "translate(-20 -392) translate(20 392)"
          })
        ])
      ])
    ], -1)
  ]))]))
}
export default { render: render }